const API_CONFIG = {
  YOUTUBE_LINK: "https://www.youtube.com/@BoloIndiaMediaNetworks",
  INSTAGRAM_LINK: "https://www.instagram.com/boloindia.medianetworks",
  LINKEDIN_LINK: "https://www.linkedin.com/company/bolo-india-media-networks",
  TWITTER_LINK: "https://x.com/boloindiamedia",
  FACEBOOK_LINK:
    "https://www.facebook.com/people/Bolo-India-Media-Networks/61587577619520/",
};

export default API_CONFIG;
